
import pic from '@/utils/pic'
const { icon1, icon2, icon3, langzh, langen,langno, langtw, langjp, langxby,langit,langdy,langfy,langhy,langty,langyn,zhsz, jtrz, sfrz, iconchecked, iconcheck,icon1_01,icon1_02,icon1_03,icon1_04,banner01,banner02,banner03 } = pic

export default {
  currency: {
    bb: 'Intercambio',
    bba: 'Cuenta de intercambio',
    hy: 'Contrato',
    jg: 'Suspensión',
    hya: 'Cuenta Contrato'
  },
  index: {
    h24: 'Volumen 24H',
    header_title: ['Elija el comercio de activos digitales ' + window.GLOBAL.LANG_TITLE.zh],
    header_small_title:'Transacción completa de activos digitales blockchain de ventanilla única',
    header_msg: 'Seguro-estable-confiable',
    register_title: 'Registrar un ' + window.GLOBAL.LANG_TITLE.zh + ' la cuenta global comienza el viaje comercial',
    register_pl: 'Por favor, introduzca su correo electrónico o número de móvil',
    register: 'Regístrese',
    featureTitleWhy: 'Por qué elegirnos',
    featureTitle: 'Seguro · estable · confiable',
    featureMsg: '',
    featureList: [
      { icon: icon1, title: 'Tecnología de billetera segura', msg: ['La tecnología de billetera fría y caliente es desarrollada por el mejor equipo de seguridad del mundo, y nunca ha habido un incidente de pérdida de monedas.',''] },
      { icon: icon2, title: 'Negocio rico en activos criptográficos', msg: ['Apoyar el comercio de derivados múltiples y al contado, etc., es su administrador personal en el mundo de los activos cifrados.',''] },
      { icon: icon3, title: 'Clientes distribuidos por todo el mundo', msg: ['Proporcione una gama completa de servicios de activos cifrados para usuarios en más de 130 países o regiones de todo el mundo.', ''] }
    ],
    bannerList: [
      {icon: banner01, title: "Comprometidos con proporcionar seguridad y estabilidad líderes en la industria", msg:["contratos inteligentes para proteger la seguridad de los activos de los inversores", "rendimiento comercial real", "garantía de servicio las 24 horas"]},
      {icon: banner02, title: "Quiero comprar y vender de inmediato mediante operaciones simples", msg:["pantalla de negociación simple", "reflejada inmediatamente en el saldo de su cuenta", "la mayoría de las criptomonedas se pueden comercializar"]},
      {icon: banner03, title: "Quiero obtener beneficios de forma activa mediante la negociación de contratos de liquidación", msg:["Abra una cuenta al mismo tiempo", "Inversión estratégica para una gran cantidad de futuros de negociación", "Puede negociar 24 horas al día, 365 días al año, incluso los fines de semana "]}
    ],
    featureList2: [
      {icon: icon1_01, title: "Transparencia y apertura", msg:["Uso de las características de blockchain y contratos inteligentes, realización de transacciones en la cadena y uso de contratos inteligentes para garantizar la seguridad de los activos de los inversores", ""] },
      {icon: icon1_02, title: "Inversión inteligente", msg:["Con las estrategias diversificadas proporcionadas por los mejores expertos en comercio cuantitativo, puede elegir", ""]},
      {icon: icon1_03, title: "Calificación de riesgo", msg:["Diseñe productos de inversión diversificados basados ​​en los diferentes riesgos y preferencias de administración de activos de cada inversor, eliminando efectivamente los umbrales de inversión", ""]},
      {icon: icon1_04, title: "Productos diversificados", msg:["Proporcione varios tipos de necesidades de inversión de los usuarios y mecanismos de plataforma flexibles, y continúe produciendo servicios financieros innovadores que sean mejores que el mercado", ""]}
    ],
    featureTitle2: 'Transacción de terminal multiplataforma en cualquier momento y en cualquier lugar',
    featureMsg2: 'Cubriendo múltiples plataformas de iOS y Android, compatible con funciones de servicio completo',
    tab: ['Moneda convencional', 'Lista de aumento 24H'],
    thead: ['nombre', 'Último precio', 'Precio más alto del día', 'Precio más bajo del día', 'Aumentar lista', 'Volumen 24H', 'operando'],
    more: 'Cargar más >',
    btn: 'Intercambio',
    dealsTitle: 'Servicio de comercio todo en uno',
    dealsTab:[
      { title: 'Intercambio', content: 'El intercambio tiene como objetivo el intercambio entre activos digitales, utilizando USDT como unidad de valoración para comprar otras monedas.'+window.GLOBAL.LANG_TITLE.zh+'Admite transacciones en tiempo real de activos digitales como Bitcoin, Ethereum y Litecoin.', src:'/static/image/deals-1.jpg', path: '' },
      { title: 'Contrato', content: 'Un derivado financiero de una moneda digital no solo admite la opción de comprar contratos de venta largos o cortos para obtener ingresos, sino que también es fácil de operar y nunca caduca.'+window.GLOBAL.LANG_TITLE.zh+'El contrato cuenta con un avanzado sistema de gestión de riesgos con apalancamiento de hasta 100 veces.', src:'/static/image/deals-2.jpg', path: '' }
    ]
  },
  market: {
    tab: ['Opcional', 'Contrato', 'Intercambio'],
    thead: ['Moneda', 'Último precio', 'Cambio 24H', 'Mínimo 24 horas', '24H más alto','Volumen 24H', 'operando'],
    nodata: 'Sin datos'
  },
  footer: {
    p: '©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
    dd: [
      {
        dt: "Sobre nosotros",
        dd: [{ title: "Perfil de la empresa", id: 1 }, { title: "Centro de ayuda", type: 'help' }]
      },
      {
        dt: "Soporte al usuario",
        dd: [
          { title: "Acuerdo del Usuario", id: 3 },
          { title: "Política de privacidad", id: 5 }
        ]
      },
      {
        dt: "Contáctenos",
        icon: true
      }
    ]
  },
  nav: {
    btn: ["iniciar sesión", "Regístrese", "gestión de activos","Descargar la aplicación"],
    nav: [
      { title: "Inicio", path: "/index",name: 'index' },
      { title: "Mercado", path: "/market",name: 'market' },
      // { title: "Intercambio", path: "/deal", name: 'deal'},
      // { title: "Contrato", path: "/deal_c", name: 'deal_c' },
      { title: "Suspensión", path: "/deal_jg", name: 'deal_jg' },
      { title: "Reembolsos en espera", path: "/profit_index",name: 'profit_index' }
    ],
    nav2: [{ title: "Mis activos", path: "/asset" }],
    menus: [
      { icon: langzh, title: "Centro de usuarios", path: "/setting" },
      { icon: langen, title: "desconectar" }
    ],
    lang: [
      { icon: langen, lang: "English", key: 'en' },
      {
        icon: langno,
        lang: "Norsk",
        key: 'no'
      },
      {"icon": langit,"lang": "Italiano","key": "it"},
      { icon: langxby, lang: "España", key: 'es' },
      { icon: langfy, lang: "français", key: 'fr' },
      { icon: langdy, lang: "Deutsche", key: 'de' },
      { icon: langjp, lang: "日本語", key: 'jp' },
      { icon: langhy, lang: "한국어", key: 'kr' },
      { icon: langty, lang: "ไทย", key: 'th' },
      { icon: langyn, lang: "Tiếng Việt", key: 'vn' },
      { icon: langzh, lang: "简体中文", key: 'zh' },
      { icon: langtw, lang: "繁體中文", key: 'tw' },
    ]
  },
  download:{
    "xz": "descargar"
  },
  // 登录
  login: {
    login: 'Ingresa, por favor',
    msg: 'Ingrese su cuenta registrada',
    list: ['móvil / correo electrónico', 'Contraseña', '¿Ha olvidado su contraseña?', 'iniciar sesión', 'Sin cuenta, regístrese ahora'],
    message: 'La cuenta o la contraseña no pueden estar vacías'
  },
  register: {
    dl: ['Inscripción móvil', 'Inscripción por correo electrónico'],
    title: 'Registrar una cuenta',
    country: 'País de ciudadanía',
    country_info: 'La información de nacionalidad no se puede modificar después del registro, asegúrese de elegir la verdad',
    account: 'cuenta',
    code_text: 'código de verificación',
    code_btn: 'Obtener CAPTCHA',
    code_unit: 's',
    code_no_data: 'se debe completar el código de verificación',
    password_text: 'Contraseña',
    password_again_text: 'Contraseña de nuevo',
    pid_text: 'Código de invitación',
    pid_pl: 'Opcional',
    invitation_code_no_data: 'Se requiere el código de invitación',
    xy: 'Acuerdo del Usuario',
    xy_no_checked: 'Por favor seleccione acuerdo',
    agree: 'He leído y estoy de acuerdo',
    register_btn: 'Regístrese',
    bz: ['La información de nacionalidad no se puede modificar después del registro, asegúrese de elegir con sinceridad.', 'Es posible que el correo electrónico de verificación se califique erróneamente como correo no deseado; revíselo con atención.', 'Por favor guarde su' + window.GLOBAL.LANG_TITLE.zh + 'Número de cuenta y contraseña de inicio de sesión.', 'No utilice la misma contraseña de inicio de sesión que otros sitios web.'],
    account_no_data: 'La cuenta no puede estar vacía',
    code_no_equality: 'Los códigos de verificación no son iguales',
    password_no_data: 'la contraseña no puede estar en blanco',
    password_no_equality: 'Las dos contraseñas no son iguales'
  },
  // 设置密码
  bindmpwd: {
    title: 'configurar la clave',
    account: 'cuenta',
    code_text: 'código de verificación',
    code_btn: 'Obtener CAPTCHA',
    code_unit: 's',
    password_text: 'Contraseña',
    password_again_text: 'Contraseña de nuevo',
    code_no_data: 'se debe completar el código de verificación',
    code_no_equality: 'Los códigos de verificación no son iguales',
    password_no_data: 'la contraseña no puede estar en blanco',
    password_no_equality: 'Las dos contraseñas no son iguales',
    bindmpwd_btn: 'Confirmar',
    phone_no_data: 'El número de teléfono no puede estar en blanco',
    password_login_text: 'Introducir la contraseña de acceso',
    password_trade_text: 'Longitud de la contraseña 6 dígitos',
    password_again_tarde_text: 'Longitud de la contraseña 6 dígitos',
  },
  // 忘记密码
  forgetpwd: {
    title: ['cambiar la contraseña', 'Se te olvidó tu contraseña'],
    account: 'cuenta',
    code_text: 'código de verificación',
    code_btn: 'Obtener CAPTCHA',
    code_unit: 's',
    password_text: 'Contraseña',
    password_again_text: 'Contraseña de nuevo',

    phone_no_data: 'El número de teléfono no puede estar en blanco',

    account_no_data: 'La cuenta no puede estar vacía',
    code_no_data: 'se debe completar el código de verificación',
    code_no_equality: 'Los códigos de verificación no son iguales',
    password_no_data: 'la contraseña no puede estar en blanco',
    password_no_equality: 'Las dos contraseñas no son iguales',
    forgetpwd_btn: 'Confirmar'
  },
  // 绑定手机号码
  bindphone: {
    title: 'Vincular número de teléfono móvil',
    phone_text: 'número de teléfono',
  },
  person: {
    more: 'Cargar más',
    no_more: 'Sin datos',
    index_center:"Centro de usuarios",
    index_menus: [
      { icon: zhsz, title: "Administración de cuentas", path: '/setting' },
      { icon: sfrz, title: "Autenticación KYC", path: '/sfyz' },
      { icon: sfrz, title: "Certificación junior", path: '/smauth' },
      { icon: sfrz, title: "Autenticación", path: '/seniorauth' },
      { icon: jtrz, title: "Autenticación de dirección", path: '/dzrz' },
      { icon: jtrz, title: "Comprar criptografía", path: '/kjmbSelect' },
      { icon: jtrz, title: "Puntaje de credito", path: '/credit' },
      { icon: jtrz, title: "Registros", path: '/deallog' },
      { icon: jtrz, title: "Registro de depósito", path: '/cbjl' },
      { icon: jtrz, title: "Registro de retiros", path: '/tbjl' },
    ],
    cbtb: 'Depósito y retirada',
    jymx: 'Detalles de la transacción',
    xyf: {
      'title': 'Puntaje de credito',
      'pgsj': 'Tiempo de evaluación'
    },
    smrz:{
       title:'KYC' ,
       sure_title:'Has sido autenticado',
       zj_type:'Tipos de documentos de indentidad válidos' ,
       zj_info:['1. La información de certificación no se puede modificar una vez verificada, por favor complete con la verdad','2. La información autenticada del nombre real no se puede volver a autenticar'],
       zj_name:'Nombre' ,
       zj_num:'Número del documento de indentidad' ,
       zj_btn:'ACEPTAR' ,
       zj_rebtn:'Vuelva a verificar' ,
       zj_sebtn:'Certificación senior' ,
       zj_type_array:[{name:'documento de indentidad de identidad',type:'idcard'}],
       idCardArr: [
        {
            id: 1,
            name: "documento de indentidad de identidad"
        },
        {
            id: 2,
            name: "Pasaporte"
        },
        {
            id: 3,
            name: "Licencia de conducir"
        },
        {
            id: 4,
            name: "permiso de residencia"
        },
        {
            id: 5,
            name: "Otro tipo de documentos identificativos"
        }
       ],
       zj_data:{city:'La nacionalidad no puede estar vacía',type:'El tipo de credencial no puede estar vacío',name:'El nombre no puede estar vacío',zj_num:'El número de identificación no puede estar vacío'},
       zsxm: 'Nombre real',
       qsrzsxm: 'Por favor, introduzca su nombre real',
       zjlx: 'Tipos de documentos de indentidad válidos',
       qxzzjlx: 'Seleccione el tipo de documento de identidad',
       sfz: 'documento de indentidad de identidad',
       zjhm: 'Número del documento de indentidad',
       qsrzjhm: 'Por favor, introduzca el número del documento de indentidad',
       sczjz: 'Subir fotos del documento de identidad',
       zjzm: 'Subir foto del anverso del documento de identidad',
       zjfm: 'Subir foto del reverso del documento de identidad',
       qsczjzm: 'Subir foto del anverso del documento de identidad',
       qsczjfm: 'Subir foto del reverso del documento de identidad',
       scqmz: 'Subir documentos de identidad y firma personal',
       qscscqmz: 'Subir documentos de identidad y firma personal',
       zj: [
         {
           id: 1,
           title: 'documento de indentidad de identidad'
         },
         {
           id: 2,
           title: 'Pasaporte'
         },
         {
           id: 3,
           title: 'Otro tipo de documentos identificativos'
         },
       ],
       tj: 'Submáscara',
       shz: 'En revisión',
       shtg: 'Aprobado'
    },
    gjrz:{
      title:'Certificación senior',
      zj_info:['1. Se admiten imágenes de menos de 8MB y en formato JPG JPEG o PNG.','2. Las fotos del documento de identidad deben ser claras y no deben ser modificadas ni bloqueadas. El número del documento fotográfico personal y el nombre del titular del documento deben ser claramente visibles.','3. Las fotos deben tomarse sin ningún tipo de tocado y se recomienda no incluir el uso de maquillaje. Los rasgos faciales de la foto deben ser claros y reconocibles y sus brazos deben estar completamente expuestos.'],
      zj_img:['/static/image/User_Center_Front_view.png','/static/image/User_Center_Back_Shot.png','/static/image/User_Center_Full_picture.png'],

    },
    zhgl:{
      title:'Configuraciones de seguridad',
      bind:[{bind_title:'Restablecer contraseña',bind_name:'Correo electrónico'},{bind_title:'Establezca la contraseña de retirada',bind_name:'Correo electrónico'}]
    },
    wdtg:{
      own_code:'Código de invitación',
      own_code_url:'Invitar a conectarse',
      own_push_title:'',
      own_push_content:['','',''],
      own_push_content_profit:['','','',''],
      own_push_content_num:['','','',''],
      own_push_profit_title: ['ID', 'ingresos', 'Marque','agregar tiempo'],
      own_push_num_title: ['ID', 'nombre', 'Teléfono','agregar tiempo'],
    },
    jyzt_td: ['hora', 'Detalles', 'Monto'],
    cbjl_td: ['hora', 'Moneda', 'Importe','estado'],
    sfrz_txt: ['KYC', 'Ha enviado la revisión, espere el resultado', 'Has superado la Certificateación senior', 'Subir foto del anverso del documento de identidad', 'Subir foto del reverso del documento de identidad', 'verificación','Error de autenticación, vuelva a autenticarse'],

    zhsz_txt: ['El nivel de seguridad de su cuenta: #', 'El nivel de seguridad de su cuenta: #，Mejorar más información para garantizar la seguridad de la cuenta'],
    zhsz_m: 'Fuerte',
    zhsz_n: 'débil',
    zhsz_p: 'No es seguro',
    zhsz_detailList: [
      { icon: '/static/image/User_Center-password.png', title: 'Contraseña de acceso ', value: 'Las cuentas de Internet corren el riesgo de ser robadas. Se recomienda que cambie su contraseña con regularidad para proteger la seguridad de su cuenta.',value2:'', btn: 'Modificación',bind_email:'Enlaza primero tu correo electrónico o teléfono móvil', path: '/forgetpwd?type=changepwd' },
      { icon: '/static/image/User_Center-password.png', title: 'Contraseña de transacción', value: 'configurar la clave', btn: 'Configurar', path: '/bindmpwd' }
    ],
    sksz_txt: ['Configuración de la colección', 'Guardar'],
    sksz_list: [
      { label: "nombre de usuario:", pl: "Por favor ingrese el nombre de usuario", key: "name" },
      { label: "Nombre de la cuenta bancaria:", pl: "Por favor, introduzca el nombre de la cuenta bancaria", key: "bank_name" },
      { label: "Cuenta bancaria:", pl: "Por favor, introduzca el número de cuenta", key: "bank_number" },
      { label: ":", pl: "", key: "alipay_account" },
      { label: "", pl: "", key: "weixin_nickname" },
      { label: "", pl: "", key: "weixin_account" }
    ]
  },
  pasination: {
    first: 'Inicio',
    prev: 'Pagina anterior',
    next: 'Siguiente página',
    last: 'última página',
    no_data: 'Sin datos',
  },
  asset: {
    title: 'Mis activos',
    zjhz: 'Transferencia de fondos',
    cb: 'Depósito',
    gz: 'Valoración del USDT',
    atnv: [],
    zh_title: 'Activos totales convertidos：',
    index_title: 'activos',
    address_title: 'Moneda',
    address_txt: ['por favor elige', 'Dirección de retirada de fondos', 'Por favor ingrese contenido', 'Marque', 'Lista de direcciones'],
    address_btn: ['añadir', 'Guardar', 'Borrar', 'Editar'],
    address_td: ['Moneda', 'Dirección de retirada de fondos', 'Marque', 'operando'],
    currency_td: ['Moneda', 'Disponible', 'Congelar', 'Cantidad convertida'],

    table_title: 'Los activos totales：',
    table_address_title: 'Dirección de retirada de fondos',
    table_td: ['Moneda', 'Disponible', 'Congelar', 'Cantidad convertida', 'operando'],
    table_btn: ['Depósito', 'Retirada de fondos', 'Registro', 'Transferir'],

    money_text: ['Dirección de retirada de fondos', 'por favor elige', 'Importe', 'Disponible：', 'Tarifa',
      'Importe a retirar', 'Contraseña de transacción','etiqueta(Memo)','Mínimo'],
    money_btn: 'Retirada de fondos',
    xzbz: 'Selección de moneda',
    money_msg: ['recordatorio ',' ', '','','',''],

    recharge_title: 'Dirección de depósito',
    recharge_btn: ['Copiar', 'Código QR', 'Depósito'],
    recharge_text: ['Importe', 'recordatorio', 'Por favor, no ingrese ningún activo que no sea en moneda local en la dirección mencionada o los activos no se recuperarán', 'Los depósitos del USDT solo admiten el método de envío simple. Los depósitos que utilicen otros métodos (enviar todos) no se pueden contabilizar temporalmente. Por favor, comprenda.', 'certificado', 'Descripción del bono(Opcional)','Nombre de la cadena'],

    record_title: 'Registros financieros',
    record_td: ['Importe', 'Registro', 'Hora'],

    transfer_title: 'Transferir',
    transfer_btn: ['Todos', 'Transferir'],
    transfer_text: ['de', 'a', 'Ingrese el monto de la transferencia', 'Disponible：'],
    "bq": "Etiqueta (Memo)",
    "qsrbq": "Por favor, introduzca la etiqueta",
    "yhktx": "Retiro con tarjeta bancaria",
    "yhmc": "Nombre del banco",
    "qsryhmc": "Por favor, introduzca el nombre del banco",
    "yhzh": "Cuenta bancaria",
    "qsryhzh": "Por favor, introduzca la cuenta bancaria",
    "gjhkdm": "Código SWIFT",
    "qsrgjhkdm": "Introduzca el código SWIFT",
    "yhdz": "Dirección del banco",
    "qsryhdz": "Ingrese la dirección del banco",
    "skrxm": "Nombre del beneficiario",
    "qsrskrxm": "Ingrese el nombre del beneficiario",
    "skrdh": "Teléfono del beneficiario",
    "qsrskrdh": "Por favor, introduzca el teléfono del beneficiario",
    "skrdz": "Dirección del beneficiario",
    "qsrskrdz": "Por favor, introduzca la dirección del beneficiario"
  },
  text: {
    btn: 'espalda',
    login: 'Por favor, registrese'
  },
  deal: {
    chooseType: 'Tipo de comisión',
    choose: 'por favor elige',
    balance: 'Saldo：',
    account: ['Cuenta', 'Disponible', '/Congelar', 'Transferir'],
    dir: ['Comprar', 'Vender'],
    dir2: ['Disponible', 'Mercado'],
    cs: 'Favoritos',
    sxf: 'Tarifa',
    jye: 'Venta',
    sc_list: ['Precio de mercado', 'nombre', 'Incrementar'],
    sc_h: ['Latest', '24H Lowest', '24H Highest', '24H Vol.'],
    td_lt: ['Moneda', 'Último precio', 'Incrementar'],
    k_line_txt: ['≈', '', 'Incrementar', 'Precio más alto', 'El precio más bajo', 'Volumen 24H'],
    tabListLTitle: ["Orden actual", "Historial de ordenes "],
    tabListLEntrust: ["Comprar", "Vender"],
    tabListRTitle: ["Límite de precio", "Precio de mercado"],
    table_btn: ['Retirar fondos'],
    index_td_l: ['Hora', 'Socios comerciales', 'Importe', 'Precio', 'operando'],
    index_td_r: ['Último precio', 'Dirección', 'Precio', 'Importe'],
    index_td_r2: ['Última transacción', 'Hora', 'Precio', 'Volumen de comercio'],
    table_txt: ['terminado', 'Retirado'],

    db_1_txt: ['Disponible', 'precio de compra', 'Precio de venta', 'Aceptacion', 'Vender volumen', 'Venta', 'Compra al mejor precio del mercado', 'Vende al mejor precio del mercado', 'Comprar lote', 'Vender lote'],
    db_2_txt: ['Precio', 'Aprovechar', 'por favor elige', 'Lotes de negociación', 'Lote =', 'lotes', 'Valor de mercado del contrato', 'Bono', 'Compra al mejor precio del mercado', 'Vende al mejor precio del mercado'],
    pathList: ['Registro de contrato', 'Registro de la transacción'],
    db_btn: ['Comprar(Largo)', 'Vender(Corto)'],
    tabListLTitle2: ['Orden actual'],

    lt_btn: ['Liquidar con un clic', 'Obtenga ganancias y deje de perder', 'Cerrar posición', 'Submáscara', 'espalda'],
    lt_txt: ['Tasa de riesgo：', 'Beneficio total：'],
    lt_td: ['Tipos de','Aprovechar', 'Precio de la posición', 'Precio actual', 'Bono', 'Precio de toma de beneficios', 'Precio stop-loss', 'Hora de apertura', 'Lotes de negociación', 'Ganancia y perdida', 'operando'],
    lt_dl: ['Obtenga ganancias y deje de perder', 'Precio de toma de beneficios', 'Precio stop-loss'],

    lt_0_btn: ['Retirar fondos'],
    lt_0_td: ['Detalles de contacto', 'Moneda', 'Importe', 'Precio actual', 'Tarifa', 'operando'],

    lt_1_btn: ['Cerrar posición'],
    lt_1_txt: ['Cerrando posición'],
    lt_1_td: ['Tipos de', 'Precio de la posición', 'Precio actual', 'Bono', 'Precio de toma de beneficios', 'Precio stop-loss', 'Hora de apertura', 'Tarifa', 'Ganancia y perdida', 'operando'],
    node_data: 'Sin datos',

    lt_3_txt: ['Posición cerrada', 'Liquidación'],
    lt_3_td: ['Tipos de', 'Lotes de negociación', 'Precio de la posición', 'Precio de cierre', 'Precio de toma de beneficios', 'Precio stop-loss', 'Bono', 'Margen disponible', 'Hora de apertura', 'Hora de cierre', 'Tarifa',
      'Ganancia y perdida', 'operando'],

    lt_4_txt: ['Retirado'],
    cm: ['Hora de salida', 'Número de edición', 'Circulación total', 'Precio total', 'Sitio web oficial','Papel blanco','Información'],
    qsrsl: 'Introducir el importe',
    qsrss: 'Entrar en Lotes de Negociación',
  },
  notice:{
      notice_title:'Centro de anuncios',
  },
  bzhl:{
    title: 'Reembolsos en espera',
    ttzbt: 'Sigue ganando dinero todos los días',
    wdtg: 'Pedir deposito en garantía ',
    zztgdzj: 'Fondos en custodia',
    yjjrsy: 'Ingresos del día',
    ljsy: 'Ingresos acumulados',
    tgzdd: 'Pedido en custodia',
    tgdd: 'Pedido en custodia',
    t1: 'Gestión financiera estable y de bajo riesgo, reembolsable en cualquier momento si es necesario',
    t2: 'Su asistente de administración de dinero gratuito',
    cljxcp: 'Ciclo del producto',
    dbxe: 'Límite único',
    rsyl: 'Producir(%)',
    rsyl2: 'Tasa de rendimiento diaria：',
    zq: 'Ciclo',
    qmr: 'Comprar',
    ckgd: 'más',
    cpgk: 'Descripción del producto',
    pxsj: 'Tiempo de dividendo',
    tgzj: 'Capital en custodia',
    tqsh: 'Retorno anticipado',
    cpld: 'Destacados del producto',
    cpgz: 'regla',
    cont: 'La ganancia de USDT es administrada por el equipo profesional de la plataforma alojando USDT en la plataforma. Los participantes pueden obtener la participación en los ingresos de la plataforma durante el período de custodia del fondo, al que se puede acceder en cualquier momento, lo cual es seguro y conveniente.',
    zj: '100%fondos',
    aqbz: 'Seguridad',
    jjrsy: 'Ingresos de vacaciones',
    bjd: 'Ininterrumpido',
    cgcrh: 'Después de un depósito exitoso',
    dtqx: 'Calcule el interés del día',
    ljzr: 'Transfiera ahora',
    xqglgj: 'Herramientas gratuitas de administración de dinero',
    ddh: 'Número de pedido',
    tgje: 'Importe de la custodia',
    tgsj: 'tiempo de la custodia',
    yhl: 'Beneficios obtenidos/días restantes',
    xdsj: 'Tiempo de pedido',
    zt: 'estado',
    fh: 'espalda',
    qrnhsy: 'Ingreso anualizado de siete días',
    ygy: '1 mes',
    bn: 'Medio año',
    yn: '1 año',
    yuan: '$',
    tzfx: 'riesgo de inversión',
    shsc: 'Tiempo de redención',
    di: 'bajo',
    yggzr: 'Un día laborable',
    msgsxf: 'Cuota de suscripción gratuita',
    mr: 'Diario',
    dqfh: 'Retorno a vencimiento',
    ljgm: 'Comprar ahora',
    tgz: 'Pedido en custodia',
    sh: 'Retorno anticipado',
    ywc: 'terminado',
    ysh: 'Recuperar',
    all: 'Todos',
    "xzbzts": "Sencillo y seguro. Los dividendos se pueden seleccionar en varias monedas",
    "qtbz": "Otras monedas"
  },
  pay:{
    qsrjymm: 'Longitud de la contraseña 6 dígitos',
    tbmmts: 'Vaya al centro de usuarios para configurar la contraseña de la transacción',
  },
  tips:{
    qxztbdz: 'Por favor, introduzca la dirección de retiro',
    qsrtbsl: 'Introducir el importe'
  },
  statusText: ['falla','Procesando','éxito'],
  dzrz: {
    title: 'Autenticación de dirección',
    sdddz: 'Dirección de la factura de servicios públicos',
    zdtpsc: 'Carga de imagen de factura',
    qsrsdddz: 'Debe completar la información de la dirección y enviar la factura de servicios públicos o la factura de dirección de banda ancha',
    qsczdtp: 'Sube una foto de la factura',
    status: ['En revisión','Aprobado'],
    qd: 'ACEPTAR',
  },
  jgcc: {
    wtgd: 'Orden pendiente',
    cj: 'Transacción',
    jj: 'Información',
    zc: 'Actualidad',
    lszc: 'Historia',
    qblx: 'Todos los tipos',
    xj: 'Precio actual',
    sj: 'Hora',
    fx: 'Dirección',
    jg: 'Precio',
    sl: 'Importe',
    jgsj: 'Hora de entrega',
    gmj: 'Precio de compra',
    jsj: 'Precio de liquidación',
    yk: 'Ganancia y perdida',
    xq: 'Detalles',
    mz: 'Comprar largo',
    md: 'Vender en corto',
    dqye: 'Saldo actual',
    gb: 'Cerrar',
    jxxd: 'Continuar con el pedido',
    qrxd: 'Confirmar',
    ddqr: 'Confirmación de pedido',
    sxf: 'Tarifa',
    kyye: 'Equilibrio',
    jypz: 'nombre',
    jyfx: 'Dirección',
    tzje: 'Precio de la inversión',
    tzjeTips: 'Precio más bajo 0',
    dqsj: 'Hora de caducidad',
    jssj: 'Hora de entrega',
    gmsj: 'Tiempo de compra',
    sy: 'ingresos',
    zxje: 'Monto minimo ',
    shi: 'H',
    fen: 'M',
    miao: 's',
    zdje: 'Cantidad máxima ',
    qsrje: 'Ingrese el importe',
    zxtzje: 'Mínimo ',
    yebz: 'Saldo insuficiente',
    xq: 'Detalles',
    ddz: 'Esperando',
    jgjl: 'Registro de entrega',
    bz: 'Moneda',
    cz: 'operando'
  },
  kjmb: {
    title: 'Comprar criptografía',
    fzcg: 'Copiar con éxito',
    ljmb: 'Comprar criptografía',
    lxkf: 'Contactar Servicio al Cliente'
  },
  news: {
    title: 'Mis mensajes',
    "gg": "Notificación",
    ckxq: 'Ver detalles',
  },
  statusTabs:['Orden pendiente', 'En transacción','Posición cerrada', 'Retirado'],
  "chongzhi":{
    "zy": "Importante",
    "cbxx": "Información de depósito de tokens",
    "qsrsl": "Ingrese el monto del depósito",
    "tips2": "1. Compatibilidad de billetera / plataforma: es decir, la red es compatible, si la plataforma de destino no es compatible con su red de retiro, los activos no se pueden recuperar.",
    "tips3": "2. Su red de recarga y la plataforma de destino son la misma, si elige la dirección de destino es la red Ethereum, pero la recarga elige la cadena inteligente TRC20, es posible que no pueda recuperar sus activos digitales.",
    "tips4": "3. Asegúrese de que su dirección y la cantidad sean correctas antes de recargar.",
    "tips5": "Recordatorio: debido al anonimato y la privacidad de la red de bloques, una vez que ingrese la información incorrecta, perderá los activos correspondientes. Comprueba cuidadosamente tu dirección de recarga y la cantidad.",
    "tips2_1": "• No cargue ningún activo en moneda que no sea local a la dirección anterior, de lo contrario, los activos no se podrán recuperar.",
    "tips2_2": "• La moneda digital no se puede entregar a tiempo. La hora de llegada real depende de la velocidad de confirmación de la cadena de bloques.",
    "tips2_3": "• Su dirección de recarga no cambiará con frecuencia, puede recargar; si hay algún cambio, haremos todo lo posible para notificarle a través de un anuncio en el sitio web o por correo electrónico.",
  },
  "tibi": {
    "tbxx": "Información de retiro",
    "qsrbq": "Introduzca una etiqueta",
    "tbTips1": "• Para garantizar la seguridad de los fondos, cuando la política de seguridad de su cuenta cambie, la contraseña cambie, revisaremos manualmente el retiro, espere pacientemente a que el personal se comunique con usted por teléfono o correo electrónico.",
    "tbTips2": "• Asegúrese de que su computadora y navegador sean seguros para evitar que la información sea alterada o filtrada.",
    "tbTips3": "• El activo digital que mencionaste es un activo multicadena de una moneda. Independientemente de la cadena desde la que elijas subir, significa que la cantidad total de activos digitales que se muestran en la página de retiro de tu propiedad se reducirá por la cantidad correspondiente recaudada. ",
  },
  "gjlb": "Lista de países",
  "qxzgjlb": "Por favor seleccione País / Región",
  "mbwt":{
    "title": "Cuestiones de seguridad",
    "mbwt": "Cuestiones de seguridad",
    "problem":[
      {
        "id": 1,
        "title": "¿Quién es tu mejor amigo(amiga)?"
      },
      {
        "id": 2,
        "title": "¿Quien es tu idolo?"
      },
      {
        "id": 3,
        "title": "¿Dónde está tu lugar más anhelado?"
      }
    ],
    "qtxda": "Por favor, responda a la pregunta",
    "qsrxmm": "Ingrese una nueva contraseña",
    "qqrmm": "Por favor, confirme su contraseña",
    "sydqmmcz": "Restablecer con la contraseña actual",
    "zhmm": "Problemas de seguridad Recuperar contraseña",
    "ysz": "Configurar",
    "tg": "Ignorar",
    "tj": "Enviar",
    "zyts": "Importante:",
    "zytsCont": "No revele la respuesta secreta y el código de verificación, y tenga en cuenta el problema de seguridad, que lo ayudará a recuperar su contraseña."
  },
  "zc":{
    "zclb": "Lista de activos",
    "zczh": "Conversión de activos",
    "yczc": "Ocultar activos que no tiene"
  },
  "indexNew":{
    "t1": "Líder mundial",
    "t2": "Plataforma de servicios de activos digitales",
    "t3": "Transacción completa de activos digitales blockchain de ventanilla única",
    "t4": "Número de móvil / correo electrónico",
    "t5": "Regístrese ahora",
    "t6": "Dar la bienvenida a clientes de todo el mundo a través de GMO Global",
    "t7": "Descubra e inicie su viaje de cifrado"
  },
  "newReg":{
    "dl": ['Email','Móvil'],
    "cjzh": "Crear una cuenta",
    "sysjhzyx": "Número de móvil / registro de correo electrónico",
    "yhxy": "&lt;Acuerdo de usuario&gt;",
    "yhxy2": "He leído y acepto el &lt;Acuerdo de usuario&gt;",
    "yxgz": "Por favor introduzca una dirección de correo electrónico válida",
    "dhgz": "El número de teléfono móvil es incorrecto."
  },
  "indexNew2": {
    "t1": "Opere en nuestro pedido",
    "t2": "Usar Bitbank",
    "t3": "Bitbank es un intercambio ingeniosamente diseñado de bitcoins y activos cifrados. Es muy simple, conveniente, seguro y poderoso. Admite transacciones en múltiples plataformas web y de teléfonos inteligentes. Los datos y gráficos de las transacciones se actualizan en tiempo real. Completo El análisis de precios de mercado proporciona más de 60 herramientas de análisis técnico. Empiece a operar ",
    "ksjy": "Empiece a operar",
    "ly": "5 razones para elegir Bitbank",
    "item1_t1": "Volumen de operaciones líder",
    "item1_t2": "N ° 1 * Volumen de negociación de activos criptográficos",
    "item1_t3": "Negociación cómoda (experiencia comercial agradable) con alta liquidez. Enumere 12 tipos de activos criptográficos.",
    "item2_t1": "Evaluación de terceros alta",
    "item2_t2": "Entorno comercial seguro",
    "item2_t3": "Use la billetera fría sin conexión. Use Multisig para mantener alejados a los piratas informáticos. Proteja sus activos con alta tecnología",
    "item3_t1": "Aplicación confiable y fácil de usar",
    "item3_t2": "Fácil de usar y aplicación sencilla",
    "item3_t3": "Una aplicación confiable con funciones ricas. Puede mantener oportunidades comerciales fuera de la transacción.",
    "item4_t1": "Abierto todo el día",
    "item4_t2": "Puede depositar oro",
    "item4_t3": "Soporte de depósito las 24 horas, incluidos festivos",
    "item5_t1": "Smartphone y PC",
    "item5_t2": "Diseño humanizado",
    "item5_t3": "Incluso si usa un teléfono inteligente, puede realizar transacciones simples y calificadas sin dudarlo",
    "aqkk": "Seguro y confiable",
    "aqkk2": "Transacción Bitcoin de Bitbank",
    "cjzh": "Crear una cuenta",
  },
  "xbsg":{
    "title": "Moneda nueva",
    "wdsg": "Detalles",
    "scts": "Días de encierro: ",
    "sy": "restante",
    "ljsg": "Suscríbase ahora",
    "ysk": "Vendido",
    "xzjdy": "Suscríbase ahora",
    "dy": "Suscribir",
    "fxjg": "precio de emisión",
    "fxl": "Circulación",
    "ssrq": "Fecha de cotización",
    "yxqx": "Período de validez",
    "qsrsl": "Por favor ingrese la cantidad",
    "syl": "restante",
    "sgrq": "suscribir",
    "sgsl": "Monto",
    "bz": "Moneda",
    "yebz": "Saldo de USDT insuficiente",
    "tgsl": "Cantidad de pases",
    "shz": "bajo revisión",
    "wtg": "No pasó",
    "ytg": "aprobado"
  },
  "wydb":{
    "title": "Pedir prestado",
    "db": "Pedir prestado",
    "dbz": "Pedir prestado",
    "jl": "registro",
    "jdzq": "Período (días)",
    "qhk": "Volver a pagar",
    "ljdb": "Acumulativo (usdt)",
    "dhkbs" :"pago pendiente",
    "jkje": "cantidad (usdt)",
    "qsrje": "Por favor ingrese la cantidad",
    "rll": "Tasa de interés diaria",
    "hkfs": "Reembolso",
    "dqych": "Caducado",
    "lx": "Interesar",
    "fkjg": "Prestador",
    "tpsc": "Préstamo de crédito (carga de imagen)",
    "fwxx": "Información de vivienda",
    "srzm": "Comprobante de ingresos (relación laboral)",
    "yhmx": "Extracto de cuenta",
    "zjz": "foto de identificación",
    "yd": "He leído y estoy de acuerdo",
    "xy": "Solicitar un acuerdo de préstamo",
    "sqdb": "solicitar cadenas de préstamo",
    "gb": "cierre",
    "qd": "OK",
    "ts": "Por favor marque Solicitar un acuerdo de préstamo",
    "dbjl": "registro",
    "hkhth": "Código de orden",
    "wsh": "sin revisar",
    "yfk": "Préstamo",
    "sqrq": "tiempo de aplicación",
    "zq": "ciclo",
    "dbsl": "Monto",
    "zhke": "Pago total",
    "yhkxq": "Detalles de reembolso",
    "bqyhk": "Reembolsable en el período actual(USDT)",
    "hktips": "Asegúrese de que el saldo sea suficiente, si el saldo es insuficiente, recargue primero y luego pague",
    "bj": "Principal",
    "jie": "Pedir prestado",
    "ljhk": "pagar inmediatamente",
    "qcz": "Depositar",
    "yebzqxcz": "Saldo insuficiente, recargue primero y luego pague",
    "znj": "cargo del pago atrasado",
    "yqts": "Dias atrasados"
  },
  "hkxq":{
    "dd":"Pedido",
    "fzhkdz":"Copia la dirección de pago",
    "hkxq": "Detalles de reembolso",
    "zlx": "interés total",
    "zhk": "reembolsos totales",
    "hkjg": "agencia de pago",
    "qschkpz": "Cargue el certificado de reembolso",
    "hkpz": "certificado de reembolso"
  },
  "bbjyNew":{
    "jylx": "Tipos de",
    "jyze": "Cantidad"
  },
  "bind":{
    "title": "Verificacion de Email",
    "ybd": "Unido",
    "wbd": "Sin consolidar",
    "ts": "Para proteger su cuenta, se recomienda vincular una dirección de correo electrónico",
    "qsryxdz": "E-Mail-Addresse"
  },
  "tipsNew": {
    "yjj": "rechazado",
    "shz": "redención"
  },
  "newIndex2":{
    "zxhy": "Cotizaciones más recientes",
    "jypt": "Plataforma comercial",
    "dqwz": "Posición actual",
    "yzm": "Código de verificación",
    "qrmm": "Confirmar contraseña",
    "djdl": "Haz clic para iniciar sesión",
    "ghdjy": "Mejor trato",
    "ghdsh": "Mejor vida",
    "about": "El centro de intercambio de criptomonedas más innovador del mundo está aquí, donde puedes comprar, comerciar y ganar criptomonedas con cientos de criptomonedas al alcance de tu mano.",
    "index01": "Tu puerta de entrada a Bitcoin y más allá",
    "index02": "La plataforma de servicios de activos digitales líder en el mundo",
    "index03": "Todas las transacciones son gratuitas",
    "index04": "La tarifa de apertura de cuenta, la tarifa de mantenimiento de cuenta, la tarifa de límite de pérdidas, la tarifa de depósito, la tarifa de almacenamiento/entrega son todas gratuitas.",
    "index05": "Seguridad segura y segura",
    "index06": "Utilizando la experiencia que GMI INT ha acumulado desde sus inicios, estamos construyendo sistemas robustos e implementando varias medidas de seguridad para proteger de manera segura los activos de nuestros clientes.",
    "index07": "Tanto el comercio físico como el comercio apalancado están disponibles",
    "index08": "Se pueden realizar transacciones pequeñas desde alrededor de $10, el diferencial es el más estrecho de la industria y el saldo de la cuenta se puede usar como garantía para transacciones apalancadas. Solo GMI INT puede cobrar tarifas de apalancamiento.",
    "index09": "Tokens diseñados para empoderar a la comunidad GMI INT",
    "index10": "Unus Sed LEO es un token de aplicación diseñado para ayudar a los usuarios que buscan maximizar los beneficios y las funciones de la plataforma comercial GMI INT a satisfacer sus necesidades.",
    "index11": "Tokens diseñados para empoderar a la comunidad GMI INT",
    "index12": "Abre el camino a una vida mejor",
    "index13": "Todos pueden tener criptomonedas. Todos pueden intercambiar software de criptomonedas. Así es como Bitget puede llevarlo un paso más allá.",
    "index14": "Productos innovadores",
    "index15": "Copia de comercio con un clic",
    "index16": "No convertir tokens al operar",
    "index17": "Intercambios de derivados principales que respaldan el margen de USDC",
    "index18": "Control de riesgos a través del aislamiento de billetera caliente y fría",
    "index19": "Calificaciones 12 a+ de SSL Labs",
    "index20": "Seguridad confiable respaldada por Suntwin Technology, Green Pine Cloud Security, HEAP y Armors",
    "index21": "Excelente servicio al cliente",
    "index22": "Soporte en línea 24/7 en varios idiomas",
    "index23": "Soporte personalizado para clientes VIP",
    "index24": "Centro de recompensas de la comunidad",
    "index25": "Creado por comerciantes para comerciantes",
    "index26": "Intercambie varios activos digitales como Bitcoin, Ethereum, Solana y dogcoin con costos de transacción bajos",
    "index27": "Las herramientas y la información que necesita para comprar, vender, comerciar, invertir y usar criptomonedas",
    "index28": "Seguridad líder en la industria",
  },
  "langNew":{
    "szhb": "criptomoneda",
    "gjs": "Metal",
    "yy": "Crudo",
    "jy": "Comercio",
    "jmhb": "criptomoneda",
    "yxhy": "Contrato perpetuo",
    "gdjy": "orden pendiente",
    "khh": "Abrir cuenta bancaria",
    "qsrkhh": "Por favor ingrese al banco",
    "yhkh": "Cuenta bancaria",
    "qsryhkh": "Por favor, introduzca el número de cuenta bancaria",
    "mnzh":"cuenta demo",
    "cjmnzhcg":"Cuenta demo creada exitosamente",
    "tcmnzh":"Salir de la cuenta demo",
   }
}



// WEBPACK FOOTER //
// ./src/lang/es.js